import React from 'react';
import { Formik, Form, Field } from "formik";
import SimpleReactValidator from "simple-react-validator";
import { getUserRole,getLeadCategories,getLeadSubCategories } from "../utils/index";
import apiUrl from "../apiUrlConstant";
import axios from "axios";
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from "react-select";

class UpdateLeadStatus extends React.Component {
    constructor(props) {
        super(props);

        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
        });

        this.state = {
            stages: getLeadCategories(),
            subStages: [],
            currentSubStages: [],
            role: getUserRole(),
            stageSelectedLabel: '',
            subStageSelectedLabel: this.props.sub_stage || '',
            initialValues: {
                stage: this.props.stage || '',
                sub_stage: this.props.sub_stage || '',
                sub_stage_id: this.props.sub_stage_id || '',
                comment: ''
            },
            showDropFlags: this.props.stage=='inactive' && this.props.sub_stage=='Drop'?true: false,
            selectedDropReason:'',
            dropLists: [],
        };
    }

    async componentDidMount() {
        try {
            const subStages = await getLeadSubCategories();
            console.log(subStages);
            console.log(this.props);
            this.setState({
                subStages: subStages,
                initialValues:{
                    stage:this.state.stages[this.props.stage.toLowerCase()],
                    sub_stage: this.props.sub_stage || '',
                    sub_stage_id: this.props.sub_stage_id || '',
                }
            });

            if (this.props.stage) {
                this.setState({
                    currentSubStages: this.state.subStages[this.props.stage.toLowerCase()],
                    stageSelectedLabel : this.state.stages[this.props.stage.toLowerCase()]
                });
            }

            //----------------- fetch Drop reasons ----------------//

            axios.get(`${apiUrl.apiUrl.url}/leads/drop-reason-list`, {
                params: {
                    per_page: 100,
                    page: 1
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    this.setState({
                        dropLists: response.data.data
                    });
                }
            })
            .catch(() => {
                this.setState({ loading: false });
            });

        } catch (error) {
            console.error('Error in update stages:', error);
        }


        
    }

    render() {
        return (
            <div>
                <Formik
                    enableReinitialize={true}
                    initialValues={this.state.initialValues}
                    onSubmit={(values, actions) => {

                        if (this.state.showDropFlags) {
                            if (!values.drop_reason) {
                              this.validator.showMessages();
                              return false;
                            }
                          } else {
                            this.validator.message("Drop Reason", values.drop_reason,"","");
                            if (!this.validator.allValid()) {
                              this.validator.showMessages();
                              return false;
                            }
                          }

                        // if (!this.validator.allValid()) {
                        //     this.validator.getErrorMessages();
                        //     this.validator.showMessages();
                        //     return false;
                        // }

                        values.lead_id = this.props.leadId;

                        axios.post(`${apiUrl.apiUrl.url}/leads/update-lead-stages`, values)
                            .then(response => {
                                if (response.data.status === 'success') {
                                    this.props.closeModal();
                                } else {
                                    actions.setSubmitting(false);
                                    actions.setErrors(response.data);
                                }
                            });
                    }}
                >
                    {({
                        values,
                        setFieldValue,
                        handleChange,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <div className="unitFormContainerNew">
                            <Form 
                            autoComplete="off"
                            onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            e.preventDefault(); // Prevent form submission on Enter key press
                                        }
                                    }} onSubmit={handleSubmit}>
                                <div className="newGridSectionParent">
                                    <div className="newGridSectionForFormMain newGridSectionForFormMainOneFr">
                                        <div className="newGridSectionInner">
                                            <label>Stage<span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Select
                                                    className="basic-single custom-select-style"
                                                    classNamePrefix="custom-select-style-inner"
                                                    name="stage"
                                                    onChange={(selectedOption) => {
                                                        setFieldValue('stage', selectedOption.label);
                                                        setFieldValue('sub_stage', ''); // Reset sub_stage
                                                        setFieldValue('sub_stage_id','');
                                                        this.setState({
                                                            currentSubStages: this.state.subStages? this.state.subStages[selectedOption.value.toLowerCase()]:[],
                                                            stageSelectedLabel: selectedOption.label,
                                                            subStageSelectedLabel:''
                                                        });
                                                    }}
                                                    value={{
                                                        label: this.state.stageSelectedLabel,
                                                        value: values.stage,
                                                    }}
                                                    
                                                    options={Object.entries(this.state.stages).map(([key, value]) => ({    
                                                        label: value,
                                                        value: key,
                                                    }))}
                                                />
                                                {this.validator.message("Stage", values.stage, "required", { className: "text-danger" })}
                                            </div>
                                        </div>

                                        <div className="newGridSectionInner">
                                            <label>Sub Stage <span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Select
                                                    className="basic-single custom-select-style"
                                                    classNamePrefix="custom-select-style-inner"
                                                    name="sub_stage"
                                                    onChange={(selectedOption) => {
                                                        setFieldValue('sub_stage', selectedOption.originalLabel);
                                                        setFieldValue('sub_stage_id', selectedOption.value);
                                                        this.setState({
                                                            subStageSelectedLabel: selectedOption.label,
                                                            showDropFlags: values.stage=='Inactive Lead' && selectedOption.label=='Drop'? true:false
                                                        });

                                                    }}
                                                    value={{
                                                        label: this.state.subStageSelectedLabel,
                                                        value: values.sub_stage,
                                                    }}
                                                    options={this.state.currentSubStages.map((item) => ({
                                                        originalLabel: item.title,
                                                        label: item.winning_probability ? `${item.title} - Winning Probability: (${item.winning_probability}%)` : item.title,
                                                        value: item.id,
                                                    }))}
                                                />
                                                {this.validator.message("Sub stage", values.sub_stage, "required", { className: "text-danger" })}
                                            </div>
                                        </div>

                                        { this.state.showDropFlags == true ?

                                            <div className="newGridSectionInner">
                                                <label>Drop Reason <span className="astrik">*</span></label>
                                                <div className="position-relative">
                                                    <Select
                                                        className="basic-single custom-select-style"
                                                        classNamePrefix="custom-select-style-inner"
                                                        name="drop_reason"
                                                        onChange={(selectedOption) => {
                                                            setFieldValue('drop_reason', selectedOption.label);
                                                            this.setState({
                                                                selectedDropReason: selectedOption.label
                                                            });
                                                        }}
                                                        value={{
                                                            label: this.state.selectedDropReason,
                                                            value: this.state.selectedDropReason,
                                                        }}
                                                        options={this.state.dropLists.map((item) => ({
                                                            label: item.title,
                                                            value: item.title,
                                                        }))}
                                                    />
                                                    {this.validator.message("Drop Reason", values.drop_reason, "required", { className: "text-danger" })}
                                                </div>
                                            </div>
                                            : null
                                        }

                                        <div className="newGridSectionInner">
                                            <label>Comment<span className="astrik">*</span></label>
                                            <div className="position-relative">
                                                <Field as="textarea" name="comment" onChange={handleChange} />
                                                
                                                {!this.state.showDropFlags &&
                                                    this.validator.message("Comment", values.comment, "required", { className: "text-danger" })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                    <div className="button_group mt-5 d-flex align-items-center gap-2 justify-content-end">
                                        <button type="button" className='cancel_button' onClick={this.props.closeModal}>
                                            Cancel
                                        </button>
                                        <button type="submit" className='add_button' disabled={isSubmitting}>
                                            {isSubmitting && <FontAwesomeIcon icon={faSpinner} className="spinner-icon" />} Submit
                                        </button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    )}
                </Formik>
            </div>
        );
    }
}

export default UpdateLeadStatus;
